import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate, useParams } from "react-router-dom";
import Swal from 'sweetalert2';
import moment from 'moment';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

const EditProposal = (prop) => {
    prop.setShow(true);
    const [key, setKey] = useState('personal');
    const { id } = useParams();
    const userToken = localStorage.getItem("userToken");
    const navigate = useNavigate();
    const [formData, setFormData] = useState({});
    const [terms, setTerms] = useState([""]);
    const [newProduct, setNewProduct] = useState({ name: '', uom: '', qty: 0, price: 0, hsn: "" });
    const [logos, setLogos] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState({});

    // Fetch logos
    const loadLogos = () => {
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_HOST}alllogos`,
            headers: {
                'Authorization': `Bearer ${userToken}`
            }
        };

        axios.request(config)
            .then((response) => {
                setLogos(response.data.logos);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    // Fetch vendors (customers)
    const loadVendors = () => {
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_HOST}customersmine`,
            headers: {
                'Authorization': `Bearer ${userToken}`
            }
        };

        axios.request(config)
            .then((response) => {
                setVendors(response.data.customers);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    // Fetch proposal data
    const loadData = () => {
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_HOST}proposal/${id}`,
            headers: {
                'Authorization': `Bearer ${userToken}`
            }
        };

        axios.request(config)
            .then((response) => {
                const proposal = response?.data?.proposal;
                setFormData({
                    ...proposal,
                    igst: proposal.igst || 18,
                    cgst: proposal.cgst || 9,
                    sgst: proposal.sgst || 9
                });
                setTerms(proposal?.terms || [""]);
                // Set selected vendor based on proposal data
                setSelectedVendor({
                    _id: proposal?.vendorId,
                    orgName: proposal?.orgName,
                    customName: proposal?.customName,
                    phone: proposal?.customPhone,
                    address: proposal?.customAddress,
                    gstNo: proposal?.gstin,
                    customId: proposal?.customId
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    useEffect(() => {
        loadData();
        loadLogos();
        loadVendors();
    }, []);

    // Handle vendor selection
    const handleVendorSelected = (vendor) => {
        setSelectedVendor(vendor);
        setFormData({
            ...formData,
            vendorId: vendor?._id || '',
            orgName: vendor?.orgName || '',
            customName: vendor?.customName || vendor?.orgName || '',
            customPhone: vendor?.phone || '',
            customAddress: vendor?.address || '',
            gstin: vendor?.gstNo || '',
            customId: vendor?.customId || ''
        });
    };

    const handleAddTerm = () => {
        setTerms([...terms, '']);
    };

    const handleTermChange = (index, value) => {
        const newTerms = [...terms];
        newTerms[index] = value;
        setTerms(newTerms);
    };

    const handleAddProduct = () => {
        const { name, uom, qty, price, hsn } = newProduct;
        const updatedProducts = [...(formData.productDesc || []), { name, uom, qty, price, hsn }];
        setFormData({
            ...formData,
            productDesc: updatedProducts,
        });
        setNewProduct({ name: '', uom: '', qty: 0, price: 0, hsn: '' });
    };

    const handleDeleteProduct = (index) => {
        const updatedProducts = formData.productDesc.filter((product, i) => i !== index);
        setFormData({ ...formData, productDesc: updatedProducts });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        // Update selectedVendor for editable fields
        setSelectedVendor({
            ...selectedVendor,
            [name]: value
        });
    };

    const handleInputChange2 = (e) => {
        const { name, value } = e.target;
        setNewProduct((prevProduct) => ({ ...prevProduct, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let data = JSON.stringify({ ...formData, terms });

        let config = {
            method: 'patch',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_HOST}proposal/${id}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${userToken}`
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                if (response?.data.status) {
                    Swal.fire({
                        icon: "success",
                        title: "Proposal Edited Successfully",
                        showConfirmButton: false,
                        timer: 1500,
                    });
                    navigate('/proposals');
                }
            })
            .catch((error) => {
                Swal.fire({
                    icon: "warning",
                    title: error.response?.data.message,
                    showConfirmButton: false,
                    timer: 1500,
                });
            });
    };

    return (
        <div className="container-right">
            <div className='container mt-5 mb-5'>
                <h2 className='font-weight-bolder mt-4 mb-4'>Edit Proposal</h2>
                <Form onSubmit={handleSubmit}>
                    <div className='create-invoice'>
                        <Form.Group controlId="vendorIds">
                            <Form.Label>Organisation Name*</Form.Label>
                            <Form.Control
                                className='border mb-3'
                                as="select"
                                name="vendorIds"
                                value={selectedVendor?._id || ''}
                                onChange={(e) => {
                                    const vendor = e.target.value ? vendors.find(v => v._id === e.target.value) : {};
                                    handleVendorSelected(vendor);
                                }}
                            >
                                <option value="">Select Organisation</option>
                                {vendors.map((v) => (
                                    <option key={v._id} value={v._id}>{v.orgName}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>

                        <Form.Group controlId="orgName">
                            <Form.Label>Organisation Name*</Form.Label>
                            <Form.Control
                                className='border mb-3'
                                type="text"
                                placeholder="Enter Organisation Name"
                                name="orgName"
                                value={formData.orgName || ''}
                                onChange={handleInputChange}
                            />
                        </Form.Group>

                        <Form.Group controlId="customName">
                            <Form.Label>Contact Name*</Form.Label>
                            <Form.Control
                                className='border mb-3'
                                type="text"
                                placeholder="Enter Contact Name"
                                name="customName"
                                value={formData.customName || ''}
                                onChange={handleInputChange}
                            />
                        </Form.Group>

                        <Form.Group controlId="customPhone">
                            <Form.Label>Organisation Phone*</Form.Label>
                            <Form.Control
                                className='border mb-3'
                                type="text"
                                placeholder="Enter Organisation Phone"
                                name="customPhone"
                                value={formData.customPhone || ''}
                                onChange={handleInputChange}
                            />
                        </Form.Group>

                        <Form.Group controlId="customAddress">
                            <Form.Label>Organisation Address*</Form.Label>
                            <Form.Control
                                className='border mb-3'
                                type="text"
                                placeholder="Enter Organisation Address"
                                name="customAddress"
                                value={formData.customAddress || ''}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                    </div>

                    <div className='customer-invoice-tabs'>
                        <Tabs
                            id="controlled-tab-example"
                            activeKey={key}
                            onSelect={(k) => setKey(k)}
                            className="mb-3"
                        >
                            <Tab eventKey="personal" title="Item Table">
                                <div className='biiling-inshights product'>
                                    <Form.Group controlId="productDesc">
                                        <div className='mb-4'>
                                            <div className="row">
                                                <div className="col-sm product">
                                                    <label>
                                                        Product Name:
                                                        <textarea rows={1} type="text" className="form-control" name="name" value={newProduct.name} onChange={handleInputChange2} />
                                                    </label>
                                                </div>
                                                <div className="col-sm product">
                                                    <label>
                                                        UOM:
                                                        <select className="form-control" name="uom" value={newProduct.uom} onChange={handleInputChange2}>
                                                            <option></option>
                                                            <option value={'Nos'}>Nos</option>
                                                            <option value={'Litre'}>Litre</option>
                                                            <option value={'Kgs'}>Kgs</option>
                                                            <option value={'Lots'}>Lots</option>
                                                        </select>
                                                    </label>
                                                </div>
                                                <div className="col-sm product">
                                                    <label>
                                                        HSN Code:
                                                        <input type="text" className="form-control" name="hsn" value={newProduct.hsn} onChange={handleInputChange2} />
                                                    </label>
                                                </div>
                                                <div className="col-sm product">
                                                    <label>
                                                        Qty:
                                                        <input type="number" className="form-control" name="qty" value={newProduct.qty} onChange={handleInputChange2} />
                                                    </label>
                                                </div>
                                                <div className="col-sm product">
                                                    <label>
                                                        Price:
                                                        <input type="number" className="form-control" name="price" value={newProduct.price} onChange={handleInputChange2} />
                                                    </label>
                                                </div>
                                                <div className="col-sm-auto align-self-end">
                                                    <button type='button' className="btn btn-primary" id="add" onClick={handleAddProduct}>+</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='added-items'>
                                            <h6>Added Items</h6>
                                            <div className='mb-4'>
                                                <div className="row">
                                                    <div className="col-sm added">
                                                        {formData?.productDesc?.map((product, index) => (
                                                            <div key={index}>
                                                                <label>
                                                                    Product Name:
                                                                    <textarea rows={1} type="text" className="form-control" value={product.name} disabled />
                                                                </label>
                                                                <label>
                                                                    UOM:
                                                                    <input type="text" className="form-control" value={product.uom} disabled />
                                                                </label>
                                                                <label>
                                                                    HSN Code:
                                                                    <input type="text" className="form-control" value={product.hsn} disabled />
                                                                </label>
                                                                <label>
                                                                    Qty:
                                                                    <input type="number" className="form-control" value={product.qty} disabled />
                                                                </label>
                                                                <label>
                                                                    Price:
                                                                    <input type="number" className="form-control" value={product.price} disabled />
                                                                </label>
                                                                <button type='button' className="btn btn-danger btn-sm ml-2" onClick={() => handleDeleteProduct(index)}>
                                                                    -
                                                                </button>
                                                                <br />
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Form.Group>
                                </div>
                            </Tab>

                            <Tab eventKey="invoicing" title="Logo">
                                <div className='biiling-inshights product'>
                                    <Form.Group controlId="logoURL">
                                        <Form.Label>Logo Type</Form.Label>
                                        <Form.Control
                                            className='border mb-3'
                                            as="select"
                                            name="logoURL"
                                            value={formData.logoURL || ''}
                                            onChange={handleInputChange}
                                        >
                                            <option value="">Select Logo</option>
                                            {logos?.map((l) => (
                                                <option key={l.url} value={l.url}>{l.logoName}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </div>
                            </Tab>

                            <Tab eventKey="tax" title="Tax & Discount">
                                <div className='biiling-inshights product'>
                                    <Form.Group controlId="discount">
                                        <Form.Label>Discount (in %)</Form.Label>
                                        <Form.Control
                                            className='border mb-3'
                                            type="number"
                                            placeholder="Enter Discount"
                                            name="discount"
                                            value={formData.discount || ''}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="taxType">
                                        <Form.Label>Tax Type</Form.Label>
                                        <Form.Control
                                            className='border mb-3'
                                            as="select"
                                            name="taxType"
                                            value={formData.taxType || ''}
                                            onChange={(e) => setFormData({ ...formData, taxType: e.target.value })}
                                        >
                                            <option value="">Select</option>
                                            <option value="igst">IGST</option>
                                            <option value="cgst">CGST</option>
                                        </Form.Control>
                                    </Form.Group>
                                    {formData?.taxType === 'igst' ? (
                                        <Form.Group controlId="igst">
                                            <Form.Label>IGST</Form.Label>
                                            <Form.Control
                                                className='border mb-3'
                                                type="number"
                                                placeholder="Enter Tax Rate"
                                                name="igst"
                                                value={formData.igst || ''}
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>
                                    ) : (
                                        <>
                                            <Form.Group controlId="cgst">
                                                <Form.Label>CGST</Form.Label>
                                                <Form.Control
                                                    className='border mb-3'
                                                    type="number"
                                                    placeholder="Enter Tax Rate"
                                                    name="cgst"
                                                    value={formData.cgst || ''}
                                                    onChange={handleInputChange}
                                                />
                                            </Form.Group>
                                            <Form.Group controlId="sgst">
                                                <Form.Label>SGST</Form.Label>
                                                <Form.Control
                                                    className='border mb-3'
                                                    type="number"
                                                    placeholder="Enter Tax Rate"
                                                    name="sgst"
                                                    value={formData.sgst || ''}
                                                    onChange={handleInputChange}
                                                />
                                            </Form.Group>
                                        </>
                                    )}
                                </div>
                            </Tab>

                            <Tab eventKey="transactions" title="Transaction Details">
                                <div className='biiling-inshights product'>
                                    <Form.Group controlId="transNo">
                                        <Form.Label>Transaction Number</Form.Label>
                                        <Form.Control
                                            className='border mb-3'
                                            type="text"
                                            placeholder="Enter Transaction Number"
                                            name="transNo"
                                            value={formData.transNo || ''}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="transId">
                                        <Form.Label>Transaction Id</Form.Label>
                                        <Form.Control
                                            className='border mb-3'
                                            type="text"
                                            placeholder="Enter Transaction Id"
                                            name="transId"
                                            value={formData.transId || ''}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="quoteNumber">
                                        <Form.Label>Quotation Number</Form.Label>
                                        <Form.Control
                                            className='border mb-3'
                                            type="text"
                                            placeholder="Enter Quotation Number"
                                            name="quoteNumber"
                                            value={formData.quoteNumber || ''}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="customId">
                                        <Form.Label>Customer Id</Form.Label>
                                        <Form.Control
                                            className='border mb-3'
                                            type="text"
                                            placeholder="Enter Customer Id"
                                            name="customId"
                                            value={formData.customId || ''}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="gstin">
                                        <Form.Label>GSTIN</Form.Label>
                                        <Form.Control
                                            className='border mb-3'
                                            type="text"
                                            placeholder="Enter GSTIN"
                                            name="gstin"
                                            value={formData.gstin || ''}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                </div>
                            </Tab>

                            <Tab eventKey="other" title="Other">
                                <div className='biiling-inshights product'>
                                    <Form.Group controlId="vaildity">
                                        <Form.Label>Validity</Form.Label>
                                        <Form.Control
                                            className='border mb-3'
                                            type="date"
                                            placeholder="Enter Validity"
                                            name="vaildity"
                                            value={formData.vaildity ? moment(formData.vaildity).format('YYYY-MM-DD') : ''}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="shipOrHandCharge">
                                        <Form.Label>Shipping or Handling Charge</Form.Label>
                                        <Form.Control
                                            className='border mb-3'
                                            type="number"
                                            placeholder="Enter Shipping or Handling Charge"
                                            name="shipOrHandCharge"
                                            value={formData.shipOrHandCharge || ''}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="customId">
                                        <Form.Label>Customer Id</Form.Label>
                                        <Form.Control
                                            className='border mb-3'
                                            type="text"
                                            placeholder="Enter Customer's Id"
                                            name="customId"
                                            value={formData.customId || ''}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="terms">
                                        <Form.Label>Terms and Conditions</Form.Label>
                                        {terms?.map((term, index) => (
                                            <div key={index}>
                                                <Form.Control
                                                    className='border mb-3'
                                                    as="textarea"
                                                    placeholder={`Enter Term ${index + 1}`}
                                                    value={term}
                                                    onChange={(e) => handleTermChange(index, e.target.value)}
                                                />
                                            </div>
                                        ))}
                                        <Button type='button' style={{ marginLeft: "0px" }} variant="primary" onClick={handleAddTerm}>+ Add Term</Button>
                                    </Form.Group>
                                </div>
                            </Tab>
                        </Tabs>
                    </div>

                    <div className='customer-invoice-tabs'>
                        <Button variant="primary" id="draft" onClick={() => setFormData({ ...formData, proposalStatus: "draft" })} type="submit">
                            Draft
                        </Button>
                        <Button className='m-5' id="final" onClick={() => setFormData({ ...formData, proposalStatus: "complete" })} variant="primary" type="submit">
                            Save
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default EditProposal;